/**
 * Returns a boolean for whether or not the Buy Now CTA button on a product card should be visible
 * @param link buy now url link
 * @param bypassModal bypass product modal flag
 * @returns boolean => true if should show Buy Now CTA, false if should hide
 */
export function shouldShowBuyNow(link?: string, bypassModal?: boolean): boolean {
	if (!bypassModal) return true; // only hide if bypass modal flag is enabled
	if (!link?.trim()?.length) return false; // if no buy now link provided, should hide buy now button
	return true;
}